import { render, staticRenderFns } from "./Speakers.vue?vue&type=template&id=777f60a8&scoped=true&"
import script from "./Speakers.vue?vue&type=script&lang=ts&"
export * from "./Speakers.vue?vue&type=script&lang=ts&"
import style0 from "./Speakers.vue?vue&type=style&index=0&id=777f60a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f60a8",
  null
  
)

export default component.exports